//import { WorkCentreSummaryTableData } from './WorkCentreSummary.types'
import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'
import { WorkCentreServerData } from './SwitchWorkcenter.types'
//import { WORKCENTRE_STATUS_FETCH_TIMEOUT } from 'Common/Constants/Constants'

const fetchWorkcentreStatus = async (planId: string) => {
  const { data } = await request({
    url: `/plan/${planId}/workcentre-run-status`,
    method: 'get',
  })
  return data
}

export const useWorkcentreStatus = (planId: string, enabled: boolean) => {
  return useQuery(
    ['switch-workcentre-plan', planId],
    () => fetchWorkcentreStatus(planId),
    {
      select: (data) => {
        if (data?.data) {
          return data.data.map((workcentreRow: WorkCentreServerData) => {
            return {
              workCentre: workcentreRow.code,
              status: workcentreRow.status,
              sourceSite: workcentreRow.siteLabel
                ? workcentreRow.siteLabel
                : workcentreRow.siteKey,
              workCentreKey: workcentreRow.workCentreKey,
              planId: workcentreRow.PartitionKey,
              siteKey: workcentreRow.siteKey,
            }
          })
        }
        return []
      },
      cacheTime: 0,
      enabled: enabled,
      refetchOnWindowFocus: false,
    }
  )
}
